import { createContext, useState } from 'react';
import { AddAlertParam, AlertState, AlertType } from './type';

const initialState = {
    alerts: new Map<string, AlertState>()
};

type alerts = Map<string, AlertState>

const PopUpAlertContext = createContext<{
    alerts: alerts,
    addAlert?: (param: AddAlertParam) => void
}>({
    ...initialState,
    addAlert: () => { },
});

export default PopUpAlertContext;
